// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__bSZO4","actions":"GroupTable_actions__2UcSY","deleteModalFooter":"GroupTable_deleteModalFooter__2OHOB"};